import { Language } from '@lingvo-news/contracts';

// Import all flags using Vite's glob import (eager so URLs are available synchronously).
const flagModules = import.meta.glob<{ readonly default: string }>(
	'../../assets/images/flags/*.svg',
	{ eager: true }
);

export function getFlagUrl(language: Language): string {
	const flagPath = `../../assets/images/flags/${language}.svg`;
	const module = flagModules[flagPath];
	return module?.default ?? '';
}


